import { usePathname } from 'next/navigation'

const AboutBox = ({ title, description, imageSrc }) => (
  <div className="w-full lg:w-[280px] bg-transparent">
    <div className="flex lg:flex-col-reverse flex-row-reverse justify-start lg:justify-center items-center">
      <div className="w-1/2 lg:w-auto">
        <h3 className="text-left lg:text-center text-base lg:text-2xl text-textblack font-bold font-feature-settings">
          {title}
        </h3>
        <p className="text-left lg:text-center text-sm lg:text-base text-textblack font-feature-settings mt-2 lg:mt-3">
          {description}
        </p>
      </div>
      <img
        decoding="async"
        src={imageSrc}
        alt=""
        className="w-1/2 lg:w-auto h-full"
      />
    </div>
  </div>
)

export function About() {
  const pathname = usePathname()

  const contractItems = [
    {
      title: 'どこにあるかわからない「あの」契約書',
      description: 'タイトル検索だけでは見つからない参考にしたい契約書や文例',
      imageSrc: '/images/solution/img_quest09.webp'
    },
    {
      title: (
        <>
          担当者にしかわからない
          <br />
          交渉経緯
        </>
      ),
      description: '契約交渉プロセスのブラックボックス化により、確認作業が大変',
      imageSrc: '/images/solution/img_quest02.webp'
    },
    {
      title: (
        <>
          最終チェックで作業時間
          <br />
          が結局倍に
        </>
      ),
      description: '条ズレのや表記ゆれなどの最終確認で大きく時間を浪費',
      imageSrc: '/images/solution/img_quest03.webp'
    }
  ]

  const lawItems = [
    {
      title: '法改正の影響範囲がわからない',
      description: '法改正が担当している文書のどこに影響するかがわからない',
      imageSrc: '/images/solution/img_quest10.webp'
    },
    {
      title: (
        <>
          法改正に対応
          <br />
          できているか不安
        </>
      ),
      description: '法改正の内容について元にする情報が最新のものかどうか不安',
      imageSrc: '/images/solution/img_quest11.webp'
    },
    {
      title: (
        <>
          改訂に伴う作業が
          <br />
          大変
        </>
      ),
      description:
        'バージョン管理や新旧対照表の作成など、膨大かつ煩雑な作業が多い',
      imageSrc: '/images/solution/img_quest12.webp'
    }
  ]

  const regulationItems = [
    {
      title: 'イチから新規程を作るのが大変',
      description: '情報収集や書籍からWordに落とし込むのに時間がかかってしまう',
      imageSrc: '/images/solution/img_quest04.webp'
    },
    {
      title: (
        <>
          法令改正に対応できて
          <br />
          いるか不安
        </>
      ),
      description:
        '最新の法令のチェックはしたがどのように直せばよいかわからない',
      imageSrc: '/images/solution/img_quest05.webp'
    },
    {
      title: (
        <>
          改訂に伴う作業が
          <br />
          大変
        </>
      ),
      description: 'バージョン管理や新旧対照表の作成など煩雑な作業が多い',
      imageSrc: '/images/solution/img_quest06.webp'
    }
  ]

  const translationItems = [
    {
      title: (
        <>
          内容の把握だけでも
          <br />
          大変
        </>
      ),
      description: '英文契約書だといつも以上に時間がかかってしまう',
      imageSrc: '/images/solution/img_quest07.webp'
    },
    {
      title: '専門用語や自社独自の表現がうまく翻訳できない',
      description: '翻訳精度が下がり、翻訳結果を活用できない',
      imageSrc: '/images/solution/img_quest08.webp'
    },
    {
      title: '過去の英文の言い回しが見つけられない',
      description: '過去使った言い回しを使いたいのに見つけられない',
      imageSrc: '/images/solution/img_quest01.webp'
    }
  ]

  const getPageContent = () => {
    switch (pathname) {
      case '/contract/':
        return {
          title: '契約書業務でこんなこと',
          items: contractItems
        }
      case '/law/':
        return {
          title: '法規制・法改正への対応でこんなこと',
          items: lawItems
        }
      case '/regulation/':
        return {
          title: '規程管理業務でこんなこと',
          items: regulationItems
        }
      case '/translation/':
        return {
          title: '英文契約書業務でこんなこと',
          items: translationItems
        }
      default:
        return null
    }
  }

  const content = getPageContent()
  if (!content) return null

  return (
    <section>
      <div className="text-center mx-auto w-full px-6 xl:px-0 py-16 lg:py-32 lg:pb-20 max-w-[1200px]">
        <h2 className="text-lg lg:text-4xl text-textblack font-bold font-feature-settings">
          {content.title}
          <br className="lg:hidden" />
          ありませんか？
        </h2>
        <div className="flex flex-wrap justify-between mt-6 lg:mt-14 gap-6">
          {content.items.map((item, index) => (
            <AboutBox key={index} {...item} />
          ))}
        </div>
      </div>
    </section>
  )
}
